import React from 'react';
import Reflux from 'reflux';
import {Link} from 'react-router-dom';
import AppActions from '../AppActions';
import * as Utilities from '../Utilities';
import reactStringReplace from 'react-string-replace';
import AppStore from '../AppStore';
import './Comment.css';
import OpenGraphLoader from './OpenGraphLoader';
class SubComment extends Reflux.Component {
    constructor (props) {
        super(props);
        this.state = {
            userLogged: false,
            user: {},
            responseEnabled: false,
            allResponsesVisible: false,
            globalTopic: this.props.globalTopic,
            currentComment: this.props.commentObject.comment,
            commentObject: this.props.commentObject,
            response: '',
            comments: [],
            parentComment: this.props.commentObject.parentComment,
            vote: this.props.commentObject.vote,
            responses: []
        };
        this.voteLess = this.voteLess.bind(this);
        this.votePlus = this.votePlus.bind(this);
        this.handleSendComment = this.handleSendComment.bind(this);
        this.handleChangeComment = this.handleChangeComment.bind(this);
        this.enableResponse = this.enableResponse.bind(this);
        this.enableAllResponses = this.enableAllResponses.bind(this);
        this.store = AppStore;
    }
    componentWillReceiveProps (newProps) {
        const commentObject = newProps.commentObject || this.state.commentObject;
        const vote = commentObject.vote;
        const currentComment = commentObject.comment;
        const parentComment = commentObject.parentComment;
        this.setState({commentObject, vote, currentComment, parentComment});
    }
    enableResponse (enable) {
        this.setState({responseEnabled: enable});
    }
    enableAllResponses () {
        this.setState({allResponsesVisible: true});
    }
    votePlus () {
        const currentComment = this.state.currentComment;
        const vote = this.state.vote;
        if (vote.plus) {
            currentComment.points = currentComment.points - 1;
            vote.plus = !vote.plus;
            vote.less = false;
            this.setState({vote});
            AppActions.voteComment(currentComment, '0');
        } else {
            if (!vote.less) {
                currentComment.points = currentComment.points + 1;
            } else if (vote.less) {
                currentComment.points = currentComment.points + 2;
            }
            vote.plus = !vote.plus;
            vote.less = false;
            this.setState({currentComment});
            AppActions.voteComment(currentComment, '+1');
        }
    }
    voteLess () {
        const currentComment = this.state.currentComment;
        const vote = this.state.vote;
        if (vote.less) {
            currentComment.points = currentComment.points + 1;
            vote.less = !vote.less;
            vote.plus = false;
            this.setState({currentComment});
            AppActions.voteComment(currentComment, '0');
        } else {
            if (!vote.plus) {
                currentComment.points = currentComment.points - 1;
            } else if (vote.plus) {
                currentComment.points = currentComment.points - 2;
            }
            vote.less = !vote.less;
            vote.plus = false;
            this.setState({currentComment});
            AppActions.voteComment(currentComment, '-1');
        }
    }
    handleSendComment () {
        const topicId = this.state.currentTopic._id;
        const newComment = {
            comment: this.state.response,
            responseTo: this.state.parentComment._id
        };
        if (!this.state.globalTopic) {
            newComment.usertopic = topicId;
        }
        AppActions.newCommentResponse(newComment);
        this.setState({response: ''});
    }
    handleChangeComment (e) {
        let value = e.target.value;
        this.setState({response: value});
    }
    renderActions () {
        let plus = false;
        let less = false;
        const vote = this.state.vote;
        const comment = this.state.currentComment;
        if (vote) {
            plus = vote.plus;
            less = vote.less;
        }
        let actions = [<div key='1' className='inline'>
          <span className={'likeComment' + (plus ? ' selected' : '')} onClick={() => this.votePlus()} ><i className='fa fa-thumbs-up' aria-hidden='true' />{comment.points}</span>
        </div>, <div key='2' className='inline'>
          <span className={'likeComment' + (less ? ' selected' : '')} onClick={() => this.voteLess()} ><i className='fa fa-thumbs-down' aria-hidden='true' /></span>
        </div>
        ];
        return actions;
    }
    render () {
        let comment = this.state.currentComment;
        let date = Utilities.getHumanTime(comment.createdAt);
        let response = <div className='responseComment'>
          <span onClick={() => this.enableResponse(true)}> Responder</span>
        </div>;
        let allResponsesBtn = <div>
          <span className='more-comment' onClick={this.enableAllResponses}> Ver las {comment.responses.length} respuestas <i className='fa fa-chevron-down' aria-hidden='true' /></span>
        </div>;
        let responseInput = <div className='row'>
          <div className='content-comment'>
            <textarea className='materialize-textarea' name='comentario' rows='1' value={this.state.response} onChange={this.handleChangeComment} placeholder='Escribí tu comentario:' />
          </div>
          <div className='btn-send'>
            <a className='btn-flat waves-effect waves-light' onClick={() => this.enableResponse(false)}>Cancelar</a>
            <input type='submit' className='option btn-block' value='Comentar' onClick={this.handleSendComment} />
          </div>
        </div>;
        let profileRedirect = comment.createdBy
          ? `/p/${comment.createdBy.username}` : '#';
        return <li key={comment._id} data-comment-id={comment._id} data-user-id='{comment.userId}' className='responseTxt'>
          <div className='image-comment-content'>
            <div className='profileThumb'>
              <Link to={profileRedirect}>
                <object type='image/jpg' data={comment.createdBy ? comment.createdBy.profile_image.sizeSmall : '/images/icons/default.jpg'}>
                  <img className='imgredes-rta img-thumbnail center-block' src='/images/icons/default-big.jpg' />
                </object>
              </Link>
            </div>
          </div>
          <div className='commentUser'>
            <ul className='actionComment'>
              <li><Link to={profileRedirect} className='commentName'>{comment.createdBy ? comment.createdBy.name : 'anonimo'}</Link></li>
              <li><a>{date + ' (' + comment.points + ')'}</a></li>
            </ul>
            <p>{reactStringReplace(comment.comment, /(#\d+)/g, (match, i) => (
              <Link key={i} to={'/topic/' + match.replace('#', '') + '_'} > {match} </Link>
            ))}</p>
            <OpenGraphLoader opengraph={comment.opengraph} />
            {this.state.responseEnabled ? '' : response}<div className='actionLike'>{this.state.userLogged ? this.renderActions(comment) : ''}</div>
            {comment.responses.length > 2 && this.state.allResponsesVisible === false ? allResponsesBtn : ''}
          </div>
          <div>
            {this.state.responseEnabled ? responseInput : ''}
            <ul />
          </div>
        </li>;
    }
}

export default SubComment;



// WEBPACK FOOTER //
// ./src/sections/SubComment.js